import sun from "./Sun.jpg"
import moon from "./Moon.jpg"
import jupiter from "./Jupiter.jpg"
import ketu from "./Ketu.jpg"
import mars from "./Mars.jpg"
import mercury from "./Mercury.jpg"
import rahu from "./Rahu.jpg"
import saturn from "./Saturn.jpg"
import ascendant from "./Ascendant.jpg"
import venus from "./Venus.jpg"


export default {
  sun,
  moon,
  jupiter,
  ketu,
  mars,
  mercury,
  rahu,
  saturn,
  ascendant,
  venus,
}
